import { TFormStatus } from "../../../shared/src/codecs/codec";
import {
    TRoadblockAction,
    TRoadblockCheckListItemAutomatic,
    TRoadblockCheckListItemManual,
    TRoadblockForm,
    TRoadblockAwaitableEntity,
    TRoadblockSignOffForm,
    TRoadblockStatus,
} from "../../../domain/codecs/form/RoadblockForm";
import { TChatsMessageForm } from "../../../domain/codecs/form/ChatsMessageForm";
import { ListingRoadblockType_displayString, TListingRoadblockDetailForm } from "../../../domain/codecs/form/ListingRoadblockForm";
import { TStaffUser2 } from "../../../domain/codecs/User";
import { TTypeOfCodec } from "../../../shared/src/codecs/codec";
import { UserName } from "../../../domain/codecs/overloads/UserName";
import { TBlockType } from "../state/router/routerTypes";
import { getRoadblockForm } from "../components/CRMRoadblock/CRMRoadblocksBlock/CRMRoadblockToFormMap";
import { underscoreToNormalEveryWordCapitalized } from "../../../shared/src/utilsByDomain/string/underscoreToNormalEveryWordCapitalized";

export type TRoadblockDetailView = {
    form_status: TFormStatus;
    display_name: string;
    linked_form: TBlockType | null;
    status: TRoadblockStatus;
    blocked_till: string | null;
    blocked_waiting_on: string;
    blocked_waiting_on_is_internal: boolean;
    blocked_by_user: TTypeOfCodec<typeof UserName> | null;
    resolved_by_user: TTypeOfCodec<typeof UserName> | null;
    resolved_on: string | null;
    checklist_items_automatic: Array<TRoadblockCheckListItemAutomatic>;
    checklist_items_manual: Array<TRoadblockCheckListItemManual>;
    actions: Array<TRoadblockAction>;
    participants: Array<TStaffUser2>;
    awaitable_entities: Array<TRoadblockAwaitableEntity>;
    chat_message_form: TChatsMessageForm;
    signoff_form: TRoadblockSignOffForm | null;
};

export const roadblockDetailViewFromCaseForm = (form: TRoadblockForm): TRoadblockDetailView => ({
    form_status: form.status,
    display_name: underscoreToNormalEveryWordCapitalized(form.children.details.roadblock_type),
    linked_form: getRoadblockForm(form.children.details.roadblock_type),
    status: form.children.details.status,
    blocked_till: form.children.details.blocked_till,
    blocked_waiting_on: form.children.details.blocked_waiting_on,
    blocked_waiting_on_is_internal: form.children.details.blocked_waiting_on_is_internal,
    blocked_by_user: form.children.details.blocked_by_user,
    resolved_by_user: form.children.details.resolved_by_user,
    resolved_on: form.children.details.resolved_on,
    checklist_items_automatic: form.children.checklist_items_automatic,
    checklist_items_manual: form.children.checklist_items_manual.map((item) => item.edited),
    actions: form.children.actions,
    participants: form.children.participants,
    awaitable_entities: form.children.awaitable_entities || [],
    chat_message_form: form.children.chat_message_form,
    signoff_form: form.children.signoff_form,
});

export const roadblockDetailViewFromListingForm = (form: TListingRoadblockDetailForm): TRoadblockDetailView => ({
    form_status: form.status,
    display_name: ListingRoadblockType_displayString(form.children.details.listing_roadblock_type),
    linked_form: null,
    status: form.children.details.status,
    blocked_till: form.children.details.blocked_till,
    blocked_waiting_on: form.children.details.blocked_waiting_on,
    blocked_waiting_on_is_internal: form.children.details.blocked_waiting_on_is_internal,
    blocked_by_user: form.children.details.blocked_by_user,
    resolved_by_user: form.children.details.resolved_by_user,
    resolved_on: form.children.details.resolved_on,
    checklist_items_automatic: form.children.checklist_items_automatic,
    checklist_items_manual: form.children.checklist_items_manual,
    actions: form.children.actions,
    participants: form.children.participants,
    awaitable_entities: form.children.awaitable_entities,
    chat_message_form: form.children.chat_message_form,
    signoff_form: null,
});
